import { render } from "./CoverageSection.vue?vue&type=template&id=7c1a9dfd&scoped=true"
import script from "./CoverageSection.vue?vue&type=script&lang=js"
export * from "./CoverageSection.vue?vue&type=script&lang=js"

import "./CoverageSection.vue?vue&type=style&index=0&id=7c1a9dfd&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1a9dfd"]])

export default __exports__